"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var DefaultFormatter_1 = require("./DefaultFormatter");
var Utils_1 = require("./Utils");
var Colors = widgets_1.TabStyles.Colors || {};
var BodyCell = /** @class */ (function (_super) {
    __extends(BodyCell, _super);
    function BodyCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickHandler = function (e) {
            if (e.defaultPrevented) {
                return;
            }
            if (_this.props.onCellClick) {
                var cell = { row: _this.props.rowIdx, col: _this.props.colIdx };
                _this.props.onCellClick(_this.props.row.data, _this.props.col.dataKey, cell, e);
            }
        };
        _this.onDoubleClickHandler = function (e) {
            if (_this.props.onCellDoubleClick) {
                var cell = { row: _this.props.rowIdx, col: _this.props.colIdx };
                _this.props.onCellDoubleClick(_this.props.row.data, _this.props.col.dataKey, cell, e);
            }
        };
        _this.onContextMenuHandler = function (e) {
            if (_this.props.onCellContextMenu) {
                var cell = { row: _this.props.rowIdx, col: _this.props.colIdx };
                _this.props.onCellContextMenu(_this.props.row.data, _this.props.col.dataKey, cell, e);
            }
        };
        return _this;
    }
    BodyCell.prototype.componentDidMount = function () {
        if (!this.props.reportWidthFn) {
            return;
        }
        this.props.reportWidthFn(this.props.col.name, Utils_1.measureWidth(this));
    };
    BodyCell.prototype.render = function () {
        var pointerEventWrapperProps = {
            pointerClick: this.onClickHandler,
            pointerDoubleClick: this.onDoubleClickHandler
        };
        var style = BodyCell.getDefaultStyle(this.props.height, this.props.width, this.props.showVerticalGridLines);
        Utils_1.assign(style, this.props.col.cellStyle || {});
        var content = this.props.col.cellFormatter
            ? this.props.col.cellFormatter(this.props)
            : React.createElement(DefaultFormatter_1.DefaultFormatter, { value: this.props.value, testId: widgets_1.testId(this.props.rowIdx + '-' + this.props.colIdx, 'Cell') });
        var attrs = {
            className: 'tb-react-dg-bcell',
            'data-tb-test-id': this.props.col.name + BodyCell.CellTestIdSuffix,
            onContextMenu: this.onContextMenuHandler,
            style: style,
            'aria-selected': this.props.isSelected
        };
        return (React.createElement(widgets_1.PointerEventWrapper, __assign({}, pointerEventWrapperProps),
            React.createElement("div", __assign({}, attrs), content)));
    };
    BodyCell.displayName = 'DataGridBodyCell';
    BodyCell.element = React.createFactory(BodyCell);
    return BodyCell;
}(React.PureComponent));
exports.BodyCell = BodyCell;
(function (BodyCell) {
    BodyCell.getDefaultStyle = function (height, width, showVerticalGridLines) {
        return {
            display: 'inline-block',
            boxSizing: 'border-box',
            height: height,
            lineHeight: height + 'px',
            width: width,
            borderRight: showVerticalGridLines ? "1px solid " + Colors.F3 : "1px solid " + Colors.Transparent,
            verticalAlign: 'top'
        };
    };
    BodyCell.CellTestIdSuffix = '-cell';
})(BodyCell = exports.BodyCell || (exports.BodyCell = {}));
exports.BodyCell = BodyCell;
//# sourceMappingURL=BodyCell.js.map